import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const linkItems = [
  { label: 'Terms of Service', to: '/help/tos' },
  { label: 'Privacy Policy', to: '/help/privacy_policy' },
  { label: 'Complaints Policy', to: '/help/complaints' },
  { label: 'Content Removal Policy', to: '/help/contentremoval' },
  { label: 'Pre-Screening and Content Moderation', to: '/help/tos#ContentModerationPolicy' },
  { label: '2257 Statement', to: '/help/statement2257' },
];

const HomeLegalLinks = () => {
  return (
    <Grid container justifyContent="center" sx={{ mt: 1 }}>
      <Grid item xs={12}>
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.75em', fontSize: '0.875em' }}>
            {linkItems.map((item) => (
              <Box key={item.to}>
                <Link
                  to={item.to}
                  style={{ textDecoration: 'none' }}
                >
                  {item.label}
                </Link>
              </Box>
            ))}
          </Box>
          <Box sx={{ mt: 3, px: 1 }}>
            <Typography variant="body2" sx={{ color: '#999', fontSize: '0.75em' }}>
              ©
              {new Date().getFullYear()}
              &nbsp;NF Entertainment, Inc. All rights reserved. Flirts are not employees of NiteFlirt. NiteFlirt is for entertainment purposes only.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <img src="/niteflirt/images/redesign/rapidssl.gif" alt="Secure site" />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default HomeLegalLinks;
